import constants from '../constants'
import Dispatcher from '../dispatcher'

const Actions = {
  changeAnchor: (id) => {
    Dispatcher.handleAppAction({
      type: constants.CHANGE_ANCHOR,
      item: id
    })
  },
  changeMenuVisibility: (bool) => {
    Dispatcher.handleAppAction({
      type: constants.CHANGE_MENU_VISIBILITY,
      item: bool
    })
  },
}

export default Actions
